export default __webpack_public_path__ + "static/media/propuestaElectricidadUnica.f8acb03e.svg";